import React, { useState } from "react";
import SideBar from "../../component/SideBar";
import NavBar from "../../component/NavBar";
import { NavPage } from "../NavPage.js";
import "./MainPage.css";
import { Navigate } from "react-router-dom";
import PiedPage from "../../component/PiedPage";
export default function MainPage({ checked }) {
  const [search, setSearch] = useState("");
  const [visible, setVisible] = useState(true);
  const tokenSession = sessionStorage.getItem("token");
  const tokenLocal = localStorage.getItem("tokenL");

  if (tokenSession === null && tokenLocal == null )
    return <Navigate to="/" replace />;
  else if (
    (tokenSession === null && tokenLocal !== null) ||
    tokenSession !== null
  )
 
    return (
      <div className="mainPage">
      
          <NavBar 
            checked={checked}       
            
            setVisible={setVisible}
            visible={visible}
          />
          <SideBar 
              setVisible={setVisible} 
              visible={visible}
              setSearch={setSearch}
            />
          
            <NavPage  
              search={search}
              visible={visible}
          />
            <PiedPage />
              
      </div>
    );
}
